import { getRequest } from '../../httpClient';
import type { IListPublicChallengeVsV1Response } from './list-public-challenge-vs-v1-response';
import { listPublicChallengeVsV1ResponseSchema } from './list-public-challenge-vs-v1-response';

interface IListPublicChallengeVsV1Options {
  cursor?: string;
  limit?: number;
}

/**
 * @deprecated Superseded by `listPublicChallengeVsV2Api` (adds `locales`). Frozen,
 * not deleted - an old app binary may still call it. See "Web-only / orphan
 * versions pending deletion" in apps/api/CLAUDE.md.
 */
export async function listPublicChallengeVsV1Api(options?: IListPublicChallengeVsV1Options) {
  const params: Record<string, string | number> = {};
  if (options?.cursor) {
    params.cursor = options.cursor;
  }
  if (options?.limit) {
    params.limit = options.limit;
  }
  return getRequest<IListPublicChallengeVsV1Response>({
    path: '/challenges/vs/v1',
    options: Object.keys(params).length > 0 ? { params } : undefined,
    schema: listPublicChallengeVsV1ResponseSchema,
  });
}
